// @flow

import * as React from 'react'
import styled from 'styled-components'

import type { ConnectedBrand } from '../../../types'
import { WebshopDesignPageRendererContext } from './shared'
import WebshopGridItemsRenderer from './WebshopGridItemsRenderer'

type WebshopDesignPageHeaderRendererProps = {
  brand: ConnectedBrand,
  editedGridItemId?: string | null,
  gridItems: Array<Object>,
  outsideProps: {
    onSubmitSearch: Function,
    setShowManualEditCustomerModal: Function,
    setShowRetailerSelector: Function,
    setShowSessionListModal: Function,
    showSessionManagerInNavigation: boolean,
  },
}

const WebshopDesignPageHeaderRenderer = ({
  brand,
  editedGridItemId,
  gridItems,
  outsideProps,
}: WebshopDesignPageHeaderRendererProps) => {
  const { headerBackdropGridItems } = React.useContext(
    WebshopDesignPageRendererContext
  )

  const outsidePropsWithBackdropInfo = React.useMemo(
    () => ({
      ...outsideProps,
      isOnBackdrop: headerBackdropGridItems.length > 0,
    }),
    [outsideProps, headerBackdropGridItems]
  )

  const header = (
    <WebshopGridItemsRenderer
      brand={brand}
      gridItems={gridItems}
      editedGridItemId={editedGridItemId}
      outsideProps={outsidePropsWithBackdropInfo}
    />
  )

  const headerBackdropOutsideProps = React.useMemo(() => ({ header }), [header])

  // If there are any header backdrop grid items, then we pass header to the renderer
  // via outsideProps and rely on the backdrop widget to render the header on top
  // of the backdrop
  if (headerBackdropGridItems.length > 0) {
    return (
      <WebshopGridItemsRenderer
        brand={brand}
        gridItems={headerBackdropGridItems}
        editedGridItemId={editedGridItemId}
        outsideProps={headerBackdropOutsideProps}
      />
    )
  }

  return header
}

export default WebshopDesignPageHeaderRenderer
